// Querys and Mutations
import {
  ALL_ACTIVE,
  GET_WITH_PAGINATION,
  CREATE,
  UPDATE,
  DELETE,
  GET_ALL
} from '@/graphql/config/DiscountTypesGraphql'

// models
import { Paginator, ResponseDefault } from '@/models'
import { DiscountTypeModel, DiscountTypeForm, DiscountTypesWithPagination } from '@/models/config'

// apollo
import { apolloClient } from '@/apollo'

class DiscountTypesService {
  async getAll (): Promise<DiscountTypeModel[]> {
    const result = await apolloClient.query({
      query: GET_ALL
    })
    return result.data.discountTypes
  }

  async getActivated (): Promise<DiscountTypeModel[]> {
    const result = await apolloClient.query({
      query: ALL_ACTIVE
    })
    return result.data.discountTypesActive
  }

  async getWithPagination (perPage = 10, page = 1): Promise<DiscountTypesWithPagination> {
    const result = await apolloClient.query({
      query: GET_WITH_PAGINATION,
      variables: {
        page: page,
        perPage: perPage
      }
    })
    const pagination: Paginator = result.data.discountTypesWithPagination.paginatorInfo
    const data: DiscountTypeModel[] = result.data.discountTypesWithPagination.data
    const response: DiscountTypesWithPagination = {
      objects: data,
      pagination: pagination
    }
    return response
  }

  /**
   * Mutations
   */
   async create (form: DiscountTypeForm): Promise<DiscountTypeModel> {
      const result = await apolloClient.mutate({
        mutation: CREATE,
        variables: {
          input: form
        }
      })
      return result.data.createDiscountType
  }

  async update (id: number, form: DiscountTypeForm): Promise<DiscountTypeModel> {
    const result = await apolloClient.mutate({
      mutation: UPDATE,
      variables: {
        id: id,
        input: form
      }
    })
    return result.data.updateDiscountType
  }

  async delete (id: number): Promise<ResponseDefault> {
    await apolloClient.mutate({
      mutation: DELETE,
      variables: {
        id: id
      }
    })
    return {
      success: true,
      errors: []
    }
  }
}

export default new DiscountTypesService()
